import { render, staticRenderFns } from "./editBank.vue?vue&type=template&id=63e80da6&scoped=true&"
import script from "./editBank.vue?vue&type=script&lang=js&"
export * from "./editBank.vue?vue&type=script&lang=js&"
import style0 from "./editBank.vue?vue&type=style&index=0&id=63e80da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e80da6",
  null
  
)

export default component.exports